/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions } from './FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions,
    FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsFirebase
 * Настройки приложения для Firebase.
 * Используются для авторизации на индивидуальном домене игры
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsFirebase = FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsFirebase {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsFirebase {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsFirebase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions);
    }

    return {};
}

